module.exports = __webpack_public_path__ + "static/media/Logo.de7c7935.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/some-extra- womenswear- product-shots/Logo.png
// module id = 315
// module chunks = 0